/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Application } from "~/models";

export const ApplicationInitialState: Application = {
  id: "",
  name: "",
  customer: {
    id: "",
    name: "",
  },
  owner: {
    id: "",
    firstName: "",
    lastName: "",
  },
  runbook: {
    id: "",
    name: "",
    url: "",
  },
  details: null,
  environments: [],
  removed: false,
  synchronizedAt: "",
  generalMapping: false,
  cloudAccounts: [],
  pdCustomer: "",
  pdServices: [],
  abConfigurations: [],
  nativeBackups: null,
  restore: null,
  backupRecoveryTesting: null,
  apPlans: [],
  fcPatchPlans: [],
  manualPatching: null,
  employees: [],
  externalContacts: [],
  jiraIssueKey: null,
  goLiveDate: null,
  runbookLocation: null,
  existingRunbookInclude: null,
  runbookAcceptedByMce: false,
  runbookAcceptedByCustomer: false,
  managedByCode: false,
  deploymentInstructions: "",
  jiraIntegrated: false,
  serviceDescription: "",
  providers: [],
};
